import { render, staticRenderFns } from "./Clientes.vue?vue&type=template&id=c578ebea"
import script from "./Clientes.vue?vue&type=script&lang=ts"
export * from "./Clientes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports